import { Language } from '@dvinci/attract-studio-components'

const LANGUAGE_SEGMENT_PATTERN = /^[a-z]{2}([-_][a-z0-9]{2,})?$/i

export function getLanguageSegment(path: string[]): string | undefined {
  const [firstSegment] = path

  return firstSegment && LANGUAGE_SEGMENT_PATTERN.test(firstSegment) ? firstSegment : undefined
}

export function getPathWithoutLanguageSegment(path: string[], tenantInPath?: string): string {
  const segments = [...(tenantInPath ? [tenantInPath] : []), ...path.slice(1)]

  return `/${segments.join('/')}`
}

export function getPathSegmentsWithoutLang(path: string[], activeLanguages: Language[]): string[] {
  if (!Array.isArray(path)) return []

  return path.length > 0 && activeLanguages.includes(path[0]) ? path.slice(1) : path
}

export const getLocalBaseUrl = () => {
  const port = process.env.PORT ?? 3000
  const host = 'http://localhost'
  const contextPath = process.env.NEXT_PUBLIC_CONTEXT_PATH ?? ''
  return `${host}:${port}${contextPath}`
}

export const getBaseUrl = () => {
  const domain = typeof window !== 'undefined' ? window.location.origin : ''
  const contextPath = process.env.NEXT_PUBLIC_CONTEXT_PATH ?? ''
  return `${domain}${contextPath}`
}
